import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SystemService } from '../../services/system.service';
import { IEvent } from './event.interface';


@Component({
    selector: 'app-system',
    templateUrl: 'system.component.html',
    styleUrls: ['system.component.css']
})

export class SystemComponent implements OnInit
{
    events: IEvent[];
    status: string;
    loading = false;

    constructor(private router: Router, private systemService: SystemService)
    {
    }

    onStop()
    {
        this.status = '';
        this.systemService.stopService().then(response => {
            this.status = response.status;
        });
    }

    onStart()
    {
        this.status = '';
        this.systemService.startService().then(response => {
            this.status = response.status;
        });
    }

    onRefresh()
    {
        this.loading = true;

        this.systemService.getServiceStatus().then(response => {
            this.status = response.status;
            this.systemService.getEventLog().then(events => {
                this.events = events;

                this.loading = false;
            });
        });
    }

    ngOnInit(): void
    {
        this.onRefresh();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/System/system.component.ts